import { FormControl, FormGroup, Validators } from '@angular/forms';

/**
 * Creates the standard login FormGroup shared by AdminLoginComponent and TunnelLoginComponent.
 * Includes email (required, email format), password (required, min length 2), and rememberMe.
 */
export function createLoginFormGroup(): FormGroup {
  return new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(2)]),
    rememberMe: new FormControl(false),
  });
}
